export const TEXT_TOOL_ID = "text";

export const textToolConfig = {
  id: TEXT_TOOL_ID,
  usesPreview: false,
  cursor: "text",
  onStart: ({ startPoint, setTextEditor }) => {
    setTextEditor({
      visible: true,
      x: startPoint.x,
      y: startPoint.y,
      value: "",
    });
    return false;
  },
  onMove: () => {},
  onEnd: () => {},
};

const TextToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === TEXT_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(TEXT_TOOL_ID)}
      title="Text"
      aria-label="Text"
    >
      T
    </button>
  );
};

export default TextToolButton;
